// This file is autogenerated. Any changes will be overwritten.

export const set = 'budicon';

export const name = 'calendar-empty';

export const Component = () => (
  <path d='M23.563 2.963H18.63V1.48c0-.335-.144-.479-.48-.479-.334 0-.478.144-.478.479v1.484H6.848V1.48c0-.335-.143-.479-.478-.479-.336 0-.48.144-.48.479v1.484H.959a.946.946 0 0 0-.67.288.946.946 0 0 0-.288.67v19.636c0 .24.096.479.287.67a.946.946 0 0 0 .67.288h22.606a.94.94 0 0 0 .67-.288.946.946 0 0 0 .288-.67V3.921a.946.946 0 0 0-.287-.67.946.946 0 0 0-.67-.288h-.002Zm0 5.892v14.703H.956V8.855h22.605Zm0-4.933v3.927H.956V3.922h22.605Z' />
);

export const viewBox = '0 0 25 25';
